/* eslint-disable no-undef */
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import './controls.styles.css';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ThemeContext from '../../../config/themeContext';

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isSafari = () => navigator.userAgent.match(/Safari/i);

const isFullScreen = () =>
  document.fullScreenElement ||
  document.mozFullScreen ||
  document.webkitIsFullScreen ||
  document.msFullscreenElement;

export default function FullScreenButton({ videoPlayer }) {
  const [fullscreen, setFullScreen] = useState(isFullScreen());
  const theme = useContext(ThemeContext);

  function requestFullScreen(divObj) {
    const jObj = document.getElementById(divObj).closest('div[id=video-player-container]');
    if (jObj) {
      if (jObj.webkitRequestFullScreen) {
        if (navigator.userAgent.match(/Safari/i)) {
          jObj.webkitRequestFullScreen();
        } else {
          jObj.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
        jObj.webkitRequestFullScreen();
      } else if (jObj.webkitSupportsFullscreen) {
        jObj.webkitEnterFullscreen();
      }
    }
  }

  function toggleFullScreen() {
    const idComponent = videoPlayer.videoData.idVideoElement;
    if (!fullscreen) {
      if (isIOS()) {
        requestFullScreen(idComponent);
        return;
      }

      if (document.documentElement.requestFullScreen) document.documentElement.requestFullScreen();
      else if (document.documentElement.msRequestFullscreen)
        document.documentElement.msRequestFullscreen();
      else if (document.documentElement.mozRequestFullScreen)
        document.documentElement.mozRequestFullScreen();
      else if (document.documentElement.webkitRequestFullScreen) {
        if (isSafari()) document.documentElement.webkitRequestFullScreen();
        else document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
      return;
    }

    if (document.cancelFullScreen) document.cancelFullScreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
  }

  function handleFullScreenChange() {
    setFullScreen(isFullScreen());
  }

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange);
    document.addEventListener('mozfullscreenchange', handleFullScreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullScreenChange);
    document.addEventListener('msfullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange);
      document.removeEventListener('msfullscreenchange', handleFullScreenChange);
    };
  }, []);

  return (
    <div className="tpx-fullscreen" onClick={toggleFullScreen}>
      {fullscreen ? (
        <FullscreenExitIcon sx={theme.imageIconSmall} />
      ) : (
        <FullscreenIcon sx={theme.imageIconSmall} />
      )}
    </div>
  );
}

FullScreenButton.propTypes = {
  videoPlayer: PropTypes.object.isRequired,
};
